import {useParams} from 'react-router-dom'
import {Space} from 'antd'

import styles from './RequestOffer.module.scss'
import useStore from 'base/store'
import { PermissionType } from 'common/types'
import {
  Block,
  Modal,
  Button,
  Text,
  IconTitle,
  PenEditThirdIcon,
  VerticalDivider,
} from 'common/components'
import {formatMoney} from 'common/helpers'
import {OfferFeesForm, useGetRequest} from '..'

interface OfferButtonProps {
  request: any
}

export default function RequestOffer() {
  const params = useParams()
  const {data: request} = useGetRequest(params.uuid)
  const permissions: PermissionType[] = useStore((state) => state.permissions)

  const fees = [
    {label: 'Applic. fee', value: request.applicationFeeAmount},
    {label: 'Broker fee', value: request.brokerageFeeAmount},
    {label: 'Est. legal fee', value: request.legalFeeAmount},
  ]

  return (
    <>
      <Block className={styles.root} type="white">
        <div className={styles.block}>
          <IconTitle icon={<PenEditThirdIcon />}>Contract fees</IconTitle>
          { (!!permissions?.includes('edit loan request (signing contract)')) && (request.status === 'approved') && (
            <OfferButton request={request} />
          )}
        </div>
        <div className={styles.content}>
          <Space size={16}>
            {fees.map((fee) => (
              <div key={fee.label}>
                <Text color="grey" weight="medium" size="xs" mb={2} style={{whiteSpace: 'nowrap'}}>
                  {fee.label}
                </Text>
                <Text
                  size="xl"
                  weight="demiBold"
                  color={fee.value ? undefined : 'black30'}
                >
                  {formatMoney(fee.value)}
                </Text>
              </div>
            ))}
          </Space>
          <VerticalDivider />
          <div>
            <Text color="greenLight" weight="medium" size="xs" mb={2}>
              Facility limit 1
            </Text>
            <Text size="xl" weight="demiBold" color="green">
              {formatMoney(request.facilityLimit1 ?? 0, {cents: true})}
            </Text>
          </div>
        </div>
      </Block>
    </>
  )
}

const OfferButton = ({request}: OfferButtonProps) => {
  const isOfferOpen = useStore((state) => state.isOfferOpen)
  const setOfferOpen = useStore((state) => state.setOfferOpen)

  const handleOfferOpen = () => setOfferOpen(true)

  const handleOfferClose = () => setOfferOpen(false)

  return (
    <>
      <Button variant="secondary" onClick={handleOfferOpen}>
        add
      </Button>
      <Modal
        title={`‘${request.project.title}’ contract fees`}
        open={isOfferOpen}
        onCancel={handleOfferClose}
      >
        <OfferFeesForm request={request} onClose={handleOfferClose} />
      </Modal>
    </>
  )
}
